import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

export default function CaptureLogin(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "")
    .update([ "password" ], "")
    .update([ "userIDValOnChange" ], "")
    .update([ "passwordValOnChange" ], "")
    .submit();

    return <LoginPage data={ data } />
}